import React from 'react';

import { styled } from '@mui/material';

import { CloseButton } from '../buttons/close-button';

export type ModalProps = {
  size?: 'small';
  close: () => void;
};

export const Modal = React.forwardRef<
  HTMLDialogElement,
  React.PropsWithChildren<ModalProps>
>(({ children, size, close }, ref) => (
  <div>
    <Dialog ref={ref} size={size}>
      <IconContainer>
        <StyledCloseButton onClick={close} />
      </IconContainer>
      {children}
    </Dialog>
  </div>
));

interface ContainerProps {
  size?: 'small';
}

const Dialog = styled('dialog')<ContainerProps>(({ theme, size }) => ({
  width: '335px',
  inset: '0 0 0 0',
  position: 'fixed',
  backgroundColor: 'white',
  padding: 'var(--spacer-m) var(--spacer-l) var(--spacer-l)',
  animation: 'var(--transition-duration) ease-out show-content',
  border: 'none',

  '&::backdrop': {
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    animation: 'var(--transition-duration) ease-out show',
    backdropFilter: 'blur(75px)',
    transition:
      'opacity var(--transition-duration) linear, backdrop-filter var(--transition-duration)',

    '@keyframes show': {
      from: { opacity: 0, backdropFilter: 'none' },
      to: { opacity: 1, backdropFilter: 'blur(75px)' },
    },
  },

  '@keyframes show-content': {
    from: { transform: 'translateY(50%)' },
    to: { transform: 'translateY(0)' },
  },

  [theme.breakpoints.up('sm')]: {
    width: '673px',
  },

  [theme.breakpoints.up('md')]: {
    width: size === 'small' ? '673px' : '695px',
  },

  [theme.breakpoints.up('lg')]: {
    width: size === 'small' ? '673px' : '920px',
  },

  '&.hide': {
    transition: 'transform var(--transition-duration) ease-in',
    transform: 'translateY(50%)',

    '&::backdrop': {
      transition:
        'opacity var(--transition-duration) ease-in, backdrop-filter var(--transition-duration) ease-in',
      opacity: 0,
      backdropFilter: 'none',
    },
  },
}));

const IconContainer = styled('div')({
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-end',
  marginBottom: 'var(--spacer-m)',
});

const StyledCloseButton = styled(CloseButton)(({ theme }) => ({
  [theme.breakpoints.up(0)]: {
    svg: {
      width: '48px',
      height: '48px',
    },
  },
}));
